import axios from 'axios'
import store from '@/store'

const mailAuth = config => {
  return store.dispatch('getCurrentUser')
    .then((user) => {
      const idToken = user.tokens.IdToken
      // config.headers.Authorization = `Bearer "${idToken}"`
      config.headers.Authorization = idToken
      return Promise.resolve(config)
    })
}

const mailAuthErrorHandler = error => {
  return Promise.reject(error)
}

const mailClient = (authRequired = true) => {
  const client = axios.create({
    baseURL: process.env.VUE_APP_MAIL_SERVICE_ENDPOINT
  })
  if (authRequired) {
    client.interceptors.request.use(mailAuth, mailAuthErrorHandler)
  }
  return client
}

export default mailClient
